import { Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DwComponent, DwComponentSectionPreference, DwComponentType, DwExpressionService, DwFilterType, DwMessagingService, DwMetaDataFormStateService, DwMetaDataService, DwMetaDataServiceToken, DwOperator, DwOrmDataService, DwOrmDataServiceToken, DwQueryFilter, DwQueryHelper, DwSectionBaseComponent, DwSecurityRepositoryService, DwSecurityRepositoryServiceToken, DwSecuritySSOService, DwSecurityUserService, DwUiConfigRegistryService, DwUIMetaDataConfig, DwUIMetaDataConfigToken } from '@devwareapps/devware-cap';
import { AppMetaDataLookups, AppMetaDataService, EmsUserExtendedEntity, UserExtendedEntity } from 'src/app/meta-data/app-meta-data.service';
import { ConfigService } from 'src/environments/environment';

@Component({
  selector: 'app-employee-banner',
  templateUrl: './employee-banner.component.html',
  styleUrls: ['./employee-banner.component.scss']
})

@DwComponent({
  name: 'EmployeeBanner',
  parentItemName: 'ems_UserExtended', //unique item name from wapps metadata
  componentType: DwComponentType.formSection,
})



export class EmployeeBanner extends DwSectionBaseComponent<DwComponentSectionPreference>
  implements OnInit {

  name: string = "";
  company: string = "";
  department: string = "";
  team: string = "";
  title: string = "";
  employmentStatus: string = "";
  employeeType: string = "";
  phoneNumber: string = "";
  emailAddress: string = "";
  streetAddress1: string = "";
  streetAddress2: string = "";
  city: string = "";
  state: string = "";
  postalCode: string = "";

  streetAddress: string = "";
  cityStateZip: string = "";

  AXID: string = "";


  photoUrl: string = "";
  phoneLink: string = "";
  emailLink: string = "";
  addressLink: string = "";

  LookupId: number = null;
  selectedId: number = null;
  hasPhone: boolean = true;
  lastUserId: any;
  cellNumber: string;
  hasCell: boolean = true;
  cellLink: string;
  yrsService: string = "";
  isWachterEmployee: boolean = true;
  userType: string = "";
  staffingAgencyName: string = "";

  constructor(dwExpressionService: DwExpressionService,
    dwUiConfigRegistryService: DwUiConfigRegistryService,
    private msalHandler: DwSecuritySSOService,
    @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
    @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,
    @Inject(DwOrmDataServiceToken) private dataService: DwOrmDataService,
    @Inject(DwMetaDataFormStateService) private dwMetaDataFormStateService: DwMetaDataFormStateService,
     private securityService: DwSecurityUserService,
    @Inject(DwSecurityRepositoryServiceToken) private securityRepository: DwSecurityRepositoryService,
    private messageService: DwMessagingService) {
    super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
    }

  ngOnInit(): void {
    super.ngOnInit();

    this.formGroup.statusChanges.subscribe(x => {
      if (this.dwMetaDataFormStateService.state.formContext.loadDataComplete){
      var userId = this.UserIdControl;
      if (!(userId == null || userId == 0) && userId != this.lastUserId){
        this.lastUserId = userId;
    this.getUserProfileValues(userId);
    this.selectedId = this.EmployeeStatusControl;
    this.photoUrl = ConfigService.config.apiRoot + "/trust/ProfilePic?userId=" + this.UserIdControl.toString() + "&height=800&width=800&cropToCircle=true";
  }
      }
    })
    this.LookupId = AppMetaDataLookups.CodeValueEmsWorkStatus;

  }

  get UserIdControl(): number {
    try {
      const UserExtended: EmsUserExtendedEntity = this.dwMetaDataFormStateService.state.formApi.getFormData();
    //console.log(UserExtended);
    if (UserExtended.EmployeeEthos_UserId == null){
      return 0;
    }
    return UserExtended.EmployeeEthos_UserId;
    } catch (error) {
      return 0;
    }
  }


  getUserProfileValues(userId: number)
  {
    const md = new AppMetaDataService();
    const qh = new DwQueryHelper();

    const query = md.RoEthosUser.CreateQuery();
    const queryFilter : DwQueryFilter = new DwQueryFilter();
    queryFilter.Op = DwOperator.And;
    queryFilter.Type = DwFilterType.Equal;
    queryFilter.Value = userId.toString();
    queryFilter.Attr = md.RoEthosUser.UserId;
    query.AddFilterAnd(queryFilter)

    this.dataService.executeQuery(query).subscribe(x => {
      const data: any = x[0];
      this.name = data.NameFirstPreferedLast;
      this.company = data.Company;
      this.department = data.DepartmentName;
      this.team = data.TeamName;
      this.title = data.WachterJobTitle;
      this.employmentStatus = data.EmployeeType;
      this.employeeType = data.UserTypeDisplay;
      this.AXID = data.AXId;
      this.yrsService = data.YrsService;	
      this.userType = data.UserTypeDisplay;
      this.staffingAgencyName = data.StaffingAgencyName;
      if(this.userType == 'Contract Staffing') {this.yrsService =  "Contract Staffing", this.company = this.staffingAgencyName, this.isWachterEmployee = false}
      if(this.yrsService == "" || this. yrsService == null) {this.yrsService = "0.0";}
      if(this.company == "" || this.company == null) { this.company = "No Company"; }
      if(this.department == "" || this.department == null) { this.department = "No Department"; }
      if(this.team == "" || this.team == null) { this.team = "No Team"; }
      if(this.title == "" || this.title == null) { this.title = "No Title"; }
      if(this.employmentStatus == "" || this.employmentStatus == null) { this.employmentStatus = "No Status"; }
      if(this.employeeType == "" || this.employeeType == null) { this.employeeType = "No Employee Type"; }

      if (data.OfficePhone == '' || data.OfficePhone == null) {
        this.phoneNumber = "No Phone #";
        this.phoneLink = 'tel:'

      }
      else{
      this.phoneNumber = data.OfficePhone;
      this.phoneLink = 'tel:' + this.phoneNumber;
      }

      if (data.MobilePhone == '' || data.MobilePhone == null) {
        this.cellNumber = "No Phone #";
        this.cellLink = 'tel:'
      }
      else{
      this.cellNumber = data.MobilePhone;
      this.cellLink = 'tel:' + this.cellNumber;
      }

      if (data.Email == '' || data.Email == null) {
        this.phoneNumber = "No Email";
      }
      else{
        this.emailAddress = data.Email;
        this.emailLink = 'mailto:' + this.emailAddress;
      }
      this.streetAddress1 = data.StreetAddress1;
      this.streetAddress2 = data.StreetAddress2;
      this.StreetAddress();
      this.city = data.City;
      this.state = data.StateProvinceShortName;
      this.postalCode = data.PostalCode;
      this.CityStateZip();
    });

  }

  StreetAddress() {
    var sa1 = this.streetAddress1;
    var sa2 = this.streetAddress2;

    if(sa1 == null) { sa1 = ''; }
    if(sa2 == null) { sa2 = ''; }

    var streetAddress12 = sa1 + ' ' + sa2;
    if(streetAddress12 == '' || streetAddress12 == ' ') {
      this.streetAddress = "No Street Address";
    }
    else{
      this.streetAddress = streetAddress12;
    }
    this.addressLink = 'mailto:renee.weaver@wachter.com?subject=Email%20Address%20Change%20Request'
  }

  CityStateZip() {
    var myCity = this.city;
    var myState = this.state;
    var myZip = this.postalCode;

    if(myCity == '' || myCity == null) {
      myCity = "No City";
    }
    if(myState == '' || myState == null) {
      myState = "No State";
    }
    if(myZip == '' || myZip == null) {
      myZip = "No Zip";
    }

    this.cityStateZip = myCity + ', ' + myState + ' ' + myZip;
  }

  get EmployeeStatusControl(): number
  {
    const UserExtended: EmsUserExtendedEntity = this.dwMetaDataFormStateService.state.formApi.getFormData();

    return UserExtended.WorkStatusCv;
  }

  get UserExtendedIdControl(): number {
    const UserExtended: EmsUserExtendedEntity = this.dwMetaDataFormStateService.state.formApi.getFormData();
    if (UserExtended.UserExtendedId == null){
      return 0;
    }
    return UserExtended.UserExtendedId;

  }

  modelChangeFn(event){
    const md = new AppMetaDataService();


    //console.log(md.EmsUserExtended.ItemDetail.ItemName);
    var x = this.dataService.loadEntity(md.EmsUserExtended.ItemDetail.ItemName, this.UserExtendedIdControl).subscribe(value => {
      var formGroupValue: EmsUserExtendedEntity = value;
      //console.log(this.dataService.createDummyEntity(md.EmsUserExtended.ItemDetail.ItemName));
      formGroupValue.WorkStatusCv = this.selectedId;
      formGroupValue._itemName = md.EmsUserExtended.ItemDetail.ItemName;
      //console.log(formGroupValue);
      this.dataService.saveEntity(formGroupValue).subscribe(x =>{
        console.log("saved!");
      });
    });
  }
}
